import React, { useContext } from 'react'
import { ModalContext } from '../../contexts/ModalContext.js';
import './infomodal.scss';

const InfoModal = () => {

	const { setIsInfoModalOpen } = useContext(ModalContext)

	return (
		<div className="info-modal">
				<h2>🥳 WIR SIND ZURÜCK! 🥳</h2>
			<div className='info-modal-content'>
				<div className='info-modal-text'>
					<p>Liebe NEXARK-Community,</p>
					<p>lange hat es gedauert - und dafür möchten wir uns aufrichtig bei euch entschuldigen. In der Zwischenzeit ist einiges passiert, sowohl im Rechenzentrum als auch bei uns.</p>
					<p>Umso mehr freuen wir uns, euch mitteilen zu können: <strong>Wir sind wieder da!</strong> ❤️ Wir freuen uns riesig darauf, euch wieder auf NEXARK begrüßen zu dürfen und gemeinsam mit euch weiterzumachen.</p>
				</div>
				<p className='info-button' onClick={(e) => {setIsInfoModalOpen(false); e.preventDefault()}}>Verstanden</p>
			</div>
		</div>
	)
}

export default InfoModal;